import { adminAPIInstance, axiosInstance } from "./axiosInstance";

export const getOrderTransactions = async (page = 1, search = "") => {
  try {
    const orders = (
      await axiosInstance.get("admin/order", {
        params: {
          search: search,
          page: page,
        },
      })
    ).data;

    if (orders) {
      return orders;
    }

    return [];
  } catch (error) {
    console.log(error);
  }
};

export const getOrderDetails = async (order_id, order_attendance_id = "") => {
  try {
    const { data } = await axiosInstance.post(`admin/order/${order_id}`, {
      order_attendance_id: order_attendance_id,
    });

    if (data) {
      return data;
    }

    return [];
  } catch (error) {
    console.log(error);
  }
};

export const updateOrderInvoice = async (values) => {
  try {
    const { data } = await axiosInstance.post("admin/order/release-payment", values);

    if (data) {
      return data;
    }

  } catch (error) {
    console.log(error);
  }
};
